import { useEffect } from 'react';

/**
 * Wires an `Escape` keypress to a close handler while the modal/sidebar is open.
 * Pass `active=false` to detach (e.g., when the surface is closed) so background
 * Escape presses don't trigger close handlers from hidden modals.
 *
 *   useEscapeToClose(open, onClose);
 */
export default function useEscapeToClose(active, onClose) {
  useEffect(() => {
    if (!active || typeof onClose !== 'function') return undefined;
    const handler = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [active, onClose]);
}
